export const COMPONENT_NAME = "admin-config-commission-deposit-withdrawal";
